import React from "react";
import _ from "lodash";
import { compose } from "lib/apolloClient";
import { NoChecklistIllustration } from "@toddle-edu/ds-theme";
import { Button, EmptyState } from "@toddle-edu/ds-web";

import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./ActionTableV2.scss";
import { getTableDefaultValue } from "./ActionTableV2Utils";
import TableEditor from "./components/TableEditor";

class ActionTableV2 extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  updateTableData = ({ columns, data, columnOrder }) => {
    const { updateInputField, fieldKey, disabled } = this.props;
    if (disabled) return;
    const orderedCol = _.reduce(
      columnOrder,
      (result, col) => {
        const colObj = _.find(columns, column => _.get(column, "id") === col);
        if (colObj) {
          result.push(colObj);
        }
        return result;
      },
      []
    );

    updateInputField({
      [fieldKey]: {
        columns: orderedCol,
        data: data,
      },
    });
  };

  createEmptyTable = ({ showDefaultColumnName }) => {
    const { updateInputField, fieldKey, t } = this.props;
    updateInputField({
      [fieldKey]: getTableDefaultValue({ t, showDefaultColumnName }),
    });
  };

  renderEdit = () => {
    const {
      value,
      t,
      disabled,
      onFocusInputField,
      onBlurInputField,
      fieldTypeConfig: { emptyStateLocale = "" },
    } = this.props;

    const tableValue = value
      ? _.cloneDeep(value)
      : getTableDefaultValue({ t, showDefaultColumnName: true });
    const columns = _.get(tableValue, "columns", []);

    const onFocusInputCell = () => {
      onFocusInputField({ key: "actionPlan" });
    };

    const onBlurInputCell = () => {
      onBlurInputField({ key: "actionPlan" });
    };

    return _.size(columns) > 1 ? (
      <TableEditor
        mode={disabled ? "view" : "create"}
        value={tableValue}
        updateTableData={this.updateTableData}
        testId="actionTableV2"
        onFocusInputCell={onFocusInputCell}
        onBlurInputCell={onBlurInputCell}
      />
    ) : (
      <div className={classes.emptyStateContainer}>
        <EmptyState
          illustration={NoChecklistIllustration}
          title={t(emptyStateLocale)}
          primaryButton={
            <Button
              onClick={this.createEmptyTable}
              variant="progressive"
              size="large"
              disabled={disabled}
            >
              {t("project:create_a_table")}
            </Button>
          }
          dsVersion="2.0"
        />
      </div>
    );
  };
}

ActionTableV2.displayName = "ActionTableV2";

export default compose(I18nHOC({ resource: ["project"] }))(ActionTableV2);
